import React from "react";
import { TableRow } from "@mui/material";
import CollapsibleTableCell from "./collapsibleTableCell";
import { ICollapsibleTableCellElement } from "../../models";
import CollapsibleEmptyCheckBoxCell from "./collapsibleEmptyCheckBoxCell";

import "./collapsibleTableRow.sass";

interface ICollapsibleTableRowProps {
    expanded: boolean;
    hover?: boolean;
    tableCellElements: ICollapsibleTableCellElement[];
    rowKey: string;
    rowRefs?: React.MutableRefObject<Record<string, HTMLTableRowElement | null>>;
}

const CollapsibleTableRow: React.FC<ICollapsibleTableRowProps> = ({
    expanded,
    hover,
    tableCellElements,
    rowKey,
    rowRefs
}) => {
    return <TableRow
        ref={ref => rowRefs ? rowRefs.current[rowKey] = ref : undefined}
        key={rowKey}
        hover={hover}
        className={`collapsible-table-row ${expanded ? "expanded" : ""}`}
    >
        {
            tableCellElements.map((e, i) => 
                e.element !== undefined 
                    ? <CollapsibleTableCell
                        key={i}
                        expanded={expanded}
                        tableCellClassName={e.tableCellClassName}
                        tableCellProps={e.tableCellProps}
                    >
                        {e.element}
                    </CollapsibleTableCell>
                    : <CollapsibleEmptyCheckBoxCell key={i} expanded={expanded}/>
            )
        }
    </TableRow>;
};

export default CollapsibleTableRow;